// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__1eTO-","withMobileMargins":"DateRangeInput_withMobileMargins__3mF7U","arrowIcon":"DateRangeInput_arrowIcon__1rrZh"};